import { Validators } from '@angular/forms';

import { FieldsOptions } from '@sim/form';
import { FilterFieldsOptions } from '@ui/ui.module';

export interface Contact {
  cap: string;
  email: string;
  etichetta: string;
  nazione: string;
  numeroCivico: string;
  telefono: string;
  tipo: string; // Indirizzo postale, Email, Telefono, URL
  url: string;
  via: string;
}

export interface Person {
  id?: string;
  codiceUnico: string;
  tipo: string;
  categoria: string;
  ragioneSociale: string;
  nome: string;
  cognome: string;
  codiceFiscale: string;
  partitaIva?: string;
  contatti: Contact[];
  tag: string[];
}

export const ContactMeta: FieldsOptions<Contact> = {
  cap: {},
  email: {},
  etichetta: {},
  nazione: {},
  numeroCivico: {},
  telefono: {},
  tipo: {validators: Validators.required  },
  url: {},
  via: {},
};

export const PersonMeta: FieldsOptions<Person> = {
  categoria: { validators: Validators.required },
  codiceFiscale: {},
  cognome: {},
  contatti: { value: [], type: 'array', controls: ContactMeta },
  nome: {},
  partitaIva: {},
  ragioneSociale: {},
  tag: { value: [], type: 'array' },
  tipo: { validators: Validators.required },
};

export interface PersonFilter {
  categoria?: string;
  cognome?: string;
  id?: string;
  nome?: string;
  partitaIva?: string;
  ragioneSociale?: string;
  tipo?: string;
}

export const PersonFilterMeta: FilterFieldsOptions<PersonFilter> = {
  categoria: { operator: 'equal' },
  cognome: { operator: 'begins_with' },
  id: { operator: 'equal', typeField: 'oid' },
  nome: { operator: 'begins_with' },
  partitaIva: { operator: 'begins_with' },
  ragioneSociale: { operator: 'begins_with' },
  tipo: { operator: 'equal' },
};
